import { setLocale } from "yup";

const translateType = (type) => {
  switch (type) {
    case "number":
      return "tal";
    default:
      return type;
  }
};

setLocale({
  mixed: {
    default: "field_invalid",
    required: ({ label }) => `'${label}' er påkrævet`,
    notType: ({ label, type }) =>
      `${label} skal være af typen ${translateType(type)}`,
  },

  number: {
    min: ({ min, label }) =>
      `'${label}' skal være et tal større end eller lig med ${min}`,
    max: ({ max, label }) =>
      `'${label}' skal være et tal mindre end eller lig med ${max}`,
    integer: ({ label }) => `${label} skal være et heltal`,
  },
  array: {
    min: ({ min, label }) =>
      `Du skal vælge mindst ${min} ${label.toLocaleLowerCase()}${
        min == 1 ? "" : "r"
      }`,
    max: ({ max, label }) =>
      `Du må maks vælge ${max} ${label.toLocaleLowerCase()}${
        max == 1 ? "" : "r"
      }`,
  },
});
